import apiClient from '../apiClient';
import { POST_SET_PRIMARY_TRANSPORTATION_PROFILE_URL } from '../apiUrl';

const postSetPrimaryImageTransportationProfileApi = (id, data) => {
  return apiClient.post(POST_SET_PRIMARY_TRANSPORTATION_PROFILE_URL(id), data);
};

export default postSetPrimaryImageTransportationProfileApi;
